import { values } from './enums'

const _enum = {
  NotChecked: 0,
  Ok: 1,
  NotOk: 2,
  Resolved: 3
}

export const ProblematicCombinationState = {
  enumName: 'ProblematicCombinationState',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/problematicCombinationState.js